import React, { useMemo } from 'react'
import dayjs from 'dayjs'
import DateFormat from '../../store/types/enums/DateFormat'
import parseJsonSafe from '../../components/Schedule/parseJsonSafe'
import { History } from '../../store/redux/reducers/auditSlice'
import { WorkHoursExpandableHistoryRow } from './WorkHoursExpandableHistoryRow'
import VacationAcknowledgementExpandableHistoryRow from './VacationAcknowledgementExpandableHistoryRow'
import { ProjectAcronym, useGetProjectAcronymsByIdsQuery } from '../../store/redux/reducers/projectsSlice'

interface WorkHoursFilteredHistoryRowsProps {
  filteredAuditData: History[]
  date: string
}

export const WorkHoursFilteredHistoryRows: React.FC<WorkHoursFilteredHistoryRowsProps> = ({
  filteredAuditData,
  date,
}) => {
  const projectIDs = useMemo(() => {
    const ids = new Set<string>()
    filteredAuditData.forEach(item => {
      const oldData = parseJsonSafe(item.oldValue)
      const newData = parseJsonSafe(item.newValue)
      if (oldData?.project_id) {
        ids.add(oldData.project_id)
      }
      if (newData?.project_id) {
        ids.add(newData.project_id)
      }
    })
    return Array.from(ids)
  }, [filteredAuditData])

  const { data: acronymsData } = useGetProjectAcronymsByIdsQuery(projectIDs, {
    skip: projectIDs.length === 0,
  })

  const acronymsList: ProjectAcronym[] | undefined = acronymsData
  return (
    <>
      {filteredAuditData
        .filter(item => dayjs(item.createdAt).format(DateFormat.DayTwoMonthNameYear) === date)
        .sort((a, b) => dayjs(b.createdAt).diff(dayjs(a.createdAt)))
        .map((item, idx) => {
          const oldData = parseJsonSafe(item.oldValue)
          const newData = parseJsonSafe(item.newValue)
          const workDate = item.createdAt
          if (!workDate) return null
          if ((oldData && oldData.vacation) || (newData && newData.vacation)) {
            return <VacationAcknowledgementExpandableHistoryRow data={item} key={idx} />
          }
          return <WorkHoursExpandableHistoryRow data={item} key={idx} acronyms={acronymsList} />
        })}
    </>
  )
}
